export default {
  widgets: {
    shipmentItems: {
      filters: {
        search: {
          placeholder: 'Qidiruv...',
        },

        reset: 'Qaytish',
      },
      weekdays: ['Dush', 'Sesh', 'Chor', 'Paysh', 'Juma', 'Shan', 'Yaksh'],
      months: [
        '',
        'Yanvar',
        'Fevral',
        'Mart',
        'Aprel',
        'May',
        'Iyun',
        'Iyul',
        'Avgust',
        'Sentyabr',
        'Oktabr',
        'Noyabr',
        'Dekabr',
      ],
      selectSlotTime: 'Topshirish vaqtini tanlang',
      bronTimeSlot: 'Band qilish',
      cancel: 'Bekor qilish',
      continue: 'Davom etish',
      noTimeSlots: 'Tanlangan sanada mavjud vaqt slotlari yo‘q',
      headers: {
        name: 'Tovar nomi',
        items: 'Tovarlar',
        status: 'Holat',
        sku: 'SKU',
        ikpu: 'MXIK',
        price: "Narx (so'm)",
        price_brutto: 'Narxi QQS bilan',
        quantity: 'Omborda mavjud',
        inAlifshop: 'Alifshopda',
      },

      selectedItemsActions: {
        selectAlert: 'Topshirmoqchi bo‘lgan tovarlaringizni tanlang',
        selectedQuantity: 'Tanlangan tovarlar:',
        allItemsSelected: 'Barcha mahsulotlar tanlangan',
        clearSelectedItems: 'Tanlanganlarni bekor qilish',
      },
    },
  },
};
